import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import { OSR_JOBSITE_REPORT_QUERY } from '../../../graphql.js'
import { Table, Button, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData, getInputParams, sortColumnClicked } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const OSR_JOBSITE_REPORT = gql(OSR_JOBSITE_REPORT_QUERY)

export default function OSRJobsiteReport(props) {
  console.log('OSRJobsiteReport rendered: ', props)

  const navigate = useNavigate()
  const location = useLocation()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, OSR_JOBSITE_REPORT, 'osrJobsiteReport', setResults, setGraphQLErrors)
  }, [location])

  function viewButtonClicked(objectId) {
    const url = `/object/${objectId}?source=${location.pathname}${location.search}`
    navigate(url)
  }

  function modifyButtonClicked(objectId) {
    const url = `/object/${objectId}?actionId=${results.modifyActionId}&source=${location.pathname}${location.search}`
    navigate(url)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = []
    results.columnHeadings = [
      'Case',
      'State',
      'Sent to FW',
      'Trial Date',
      'Research Due',
      'Hard Copy Due',
      'Microfilm Due',
      'Priority (Research)',
      'Priority (Hard Copy)',
      'Priority (Microfilm)',
      'Date Research Completed',
      'Date Hard Copy Completed',
      'Date Microfilm Completed',
      'Open Companies/Vessel Names/AKA\'s',
      'Reason For Request',
      'Plaintiff Firm',
      'OSR Status',
      ''
    ]
    const canModify = results.modifyActionId ? true : false

    for (let i = 0; i < results.reportData.length; i++) {
      let dataRow = results.reportData[i]
      let objectId = dataRow[17]
      let viewButton = <Button type="button" onClick={() => viewButtonClicked(objectId)} className={objectId} color="primary" size="sm">View</Button>
      let modifyButton = ''
      if (canModify) {
        modifyButton = <Button type="button" onClick={() => modifyButtonClicked(objectId)} className={objectId} color="warning" size="sm" style={{ marginLeft: '5px' }} >Modify</Button>
      }
      let buttons = <td key={17} style={{ whiteSpace: 'nowrap' }}>{viewButton}{modifyButton}</td>
      let newJSX = []
      let listItems = dataRow[13].split('<br>')
      for (let j = 0; j < listItems.length; j++) {
        newJSX.push(<span key={j}>{listItems[j]}<br /></span>)
      }
      let row = []
      for (let j = 0; j < dataRow.length - 2; j++) {
        if (j === 13) {
          row.push(<td key={j}>{newJSX}</td>)
        } else if (j === 0) {
          row.push(<td key={-1}><b>{i + 1}</b></td>)
          row.push(<td key={0}>{results.reportData[i][j]}</td>)
        } else {
          row.push(<td key={j}>{results.reportData[i][j]}</td>)
        }
      }
      resultRows.push(<tr key={i}>{row}{buttons}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Custom/osrJobsiteReport/jobsite', location)} resultsLength={results.length} />
        </div>
        <Table bordered className="custom-table">
          <ReportHeading title={'Jobsite Report'} widths={['0%', '100%', '0%']} />
          <tbody>
            <ColumnHeadings results={results} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}
